export default "__VITE_ASSET__CWw6PSoN__"